import React, { forwardRef } from "react";

const LetterPreview = forwardRef(
  ({ letterheadUrl, direction, referenceNo, subject, body, date }, ref) => (
    <div
      ref={ref}
      style={{
        position: "relative",
        marginTop: 20,
        border: "1px solid #ccc",
        borderRadius: 10,
        overflow: "hidden",
        height: 842,
        width: 595,
        background: "#fff",
        marginLeft: "auto",
        marginRight: "auto",
        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
      }}
    >
      {/* 🔹 Letterhead background */}
      <img
        src={letterheadUrl}
        alt="Letterhead"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />

      {/* 🔹 Letter content */}
      <div
        style={{
          position: "absolute",
          top: "120px",
          left: "60px",
          right: "60px",
          bottom: "80px",
          zIndex: 2,
          fontFamily:
            direction === "rtl"
              ? "'Noto Naskh Arabic', 'Amiri', serif"
              : "Calibri, Arial, sans-serif",
          fontSize: "10pt",
          color: "#000",
          lineHeight: 1.5,
          textAlign: direction === "rtl" ? "right" : "justify",
          direction: direction,
        }}
      >
        {/* 🔹 Reference + Date block */}
        <div style={{ marginBottom: "8px", lineHeight: "1.3" }}>
          <div>
            <strong>Ref:</strong> {referenceNo || "Auto"}
          </div>
          <div>
            <strong>Date:</strong>{" "}
            {new Date(date).toLocaleDateString("en-GB")}
          </div>
        </div>

        {/* 🔹 Subject line */}
        {subject && (
          <h4
            style={{
              textAlign: direction === "rtl" ? "right" : "center",
              fontSize: "11pt",
              fontWeight: 700,
              marginTop: "0px",
              marginBottom: "6px",
            }}
          >
            {subject}
          </h4>
        )}

        {/* 🔹 Letter body */}
        <div
          dangerouslySetInnerHTML={{ __html: body }}
          style={{ marginTop: "4px" }}
        />
      </div>
    </div>
  )
);

export default LetterPreview;
